<form
  class="connect-bg connect-channel"
  (ngSubmit)="addZendesk()"
  #zendeskForm="ngForm"
  name="zendeskForm"
  fxLayout="column"
  fxLayoutAlign="space-between stretch"
>
  <h2>{{ title }}</h2>
  <h3>{{ step1Title }}</h3>
  <p [innerHTML]="registerHint"></p>
  <h3>{{ step2Title }}</h3>
  <mat-form-field fxFlex>
    <input
      fxFlex
      matInput
      [(ngModel)]="bot.zendesk_email"
      #zendesk_email="ngModel"
      name="zendesk_email"
      type="text"
      [placeholder]="emailPlaceholder"
      required
    />
  </mat-form-field>

  <mat-form-field fxFlex>
    <input
      fxFlex
      matInput
      [(ngModel)]="bot.zendesk_sitename"
      #zendesk_sitename="ngModel"
      name="zendesk_sitename"
      type="text"
      [placeholder]="domainPlaceholder"
      required
    />
    <mat-hint align="start" class="hint">{{ domainHint }}</mat-hint>
  </mat-form-field>

  <mat-form-field fxFlex>
    <input
      fxFlex
      matInput
      [(ngModel)]="bot.zendesk_token"
      #zendesk_token="ngModel"
      name="zendesk_token"
      type="text"
      [placeholder]="tokenPlaceholder"
      required
    />
    <mat-hint align="start">{{ tokenHint }}</mat-hint>
  </mat-form-field>

  @if (feedback) {
    <i class="text-feedback">{{ feedback }}</i>
  }

  <button
    mat-raised-button
    fxFlex="none"
    type="submit"
    [disabled]="!zendeskForm.form.valid"
  >
    {{ connectButton }}
  </button>
</form>
